import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Table from "../../Components/Request/Table";
import RejectModal from "../../Components/Request/RejectModal";
import InitiateTenantEviction from "../../Components/Dues/InitiateTenantEviction";
import ViewRequest from "../../Components/Request/ViewRequest";
import ReturnDeposit from "../../Components/Dues/ReturnDeposite";
import OnboardingRequestModal from "../../Components/Request/OnboardingRequestModal";
import SideModal from "../../Components/SideModal";
import RequestAcceptModal from "../../Components/Request/RequestAcceptModal";
import GuestReqAccept from "../../Components/Request/GuestReqAccept";

const Requests = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [isReqRej, setIsReqRej] = useState(false);
  const [isReqAccept, setIsReqAccept] = useState(false);
  const [isGuestReqAccept, setIsGuestReqAccept] = useState(false);
  const [initiateEviction, setInitiateEviction] = useState(false);
  const [isViewReq, setIsViewReq] = useState(false);
  const [isReturnDeposit, setIsReturnDeposit] = useState(false);
  const [onboardingRequestAccept, setOnboardingRequestAccept] = useState(false);

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/client/request/list`, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      setApiData(res.data);
      setIsFocused(true);
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  //------- Move Out Request Reject Model -------
  const MoveOutReqRejFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/tenant/request/reject`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const reqRejSuccess = (data) => {
    setIsReqRej(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const reqRejError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: reqRejLoading, mutate: reqRejMutate } = useMutation(
    MoveOutReqRejFunction,
    {
      onSuccess: reqRejSuccess,
      onError: reqRejError,
    }
  );

  //------- Onboarding Request Reject Model -------
  const OnboardingReqRejFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/request/reject`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const onboardingReqRejSuccess = (data) => {
    setIsReqRej(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const onboardingReqRejError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: onboardingReqRejLoading, mutate: onboardingReqRejMutate } = useMutation(
    OnboardingReqRejFunction,
    {
      onSuccess: onboardingReqRejSuccess,
      onError: onboardingReqRejError,
    }
  );

  //------- Refund Request Reject Model -------
  const RefundReqRejFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/tenant/request/refund/reject`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const refundReqRejSuccess = (data) => {
    setIsReqRej(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const refundReqRejError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: refundReqRejLoading, mutate: refundReqRejMutate } = useMutation(
    RefundReqRejFunction,
    {
      onSuccess: refundReqRejSuccess,
      onError: refundReqRejError,
    }
  );

  //------- Refund Request Model -------
  const RefundReqFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/request/refund/consent`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const refundReqSuccess = (data) => {
    setIsReqRej(false)
    setIsReqAccept(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const refundReqError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: refundReqLoading, mutate: refundReqMutate } = useMutation(
    RefundReqFunction,
    {
      onSuccess: refundReqSuccess,
      onError: refundReqError,
    }
  );

  //------- Guest Request Model -------
  const GuestReqFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/client/request/guest/consent`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const guestReqSuccess = (data) => {
    setIsReqRej(false)
    setIsViewReq(false);
    setIsGuestReqAccept(false)
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const guestReqError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: guestReqLoading, mutate: guestReqMutate } = useMutation(
    GuestReqFunction,
    {
      onSuccess: guestReqSuccess,
      onError: guestReqError,
    }
  );

  //------- Refund Model -------
  const ReturnDepositFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/due/settle/excess/after/eviction`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const returnDepositSuccess = (data) => {
    setIsReturnDeposit(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const returnDepositError = (data) => {
    setIsReturnDeposit(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: returnDepositLoading, mutate: returnDepositMutate } =
    useMutation(ReturnDepositFunction, {
      onSuccess: returnDepositSuccess,
      onError: returnDepositError,
    });

  //------- Approve Tenant Model -------
  const ApproveTenantFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/room/request/approve`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      }
    );
  };

  const approveTenantSuccess = (data) => {
    setOnboardingRequestAccept(false);
    getListMutate();
    toast.success(data?.data?.msg || "Success");
  };

  const approvetenantError = (data) => {
    setOnboardingRequestAccept(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: onboardingRequestLoading, mutate: onboardingRequestMutate } =
    useMutation(ApproveTenantFunction, {
      onSuccess: approveTenantSuccess,
      onError: approvetenantError,
    });

  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Requests
          <Underline />
        </BoxTitle>
      </BoxHead>
      {isReqRej && (
        <RejectModal
          setIsReqRej={setIsReqRej}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          reqRejLoading={reqRejLoading}
          reqRejMutate={reqRejMutate}
          onboardingReqRejLoading={onboardingReqRejLoading}
          onboardingReqRejMutate={onboardingReqRejMutate}
          refundReqRejLoading={refundReqRejLoading}
          refundReqRejMutate={refundReqRejMutate}
          refundReqMutate={refundReqMutate}
          refundReqLoading={refundReqLoading}
          guestReqLoading={guestReqLoading}
          guestReqMutate={guestReqMutate}
        />
      )}

      {isReqAccept && (
        <RequestAcceptModal
          setIsReqAccept={setIsReqAccept}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          refundReqLoading={refundReqLoading}
          refundReqMutate={refundReqMutate}
        />
      )}

      <SideModal
        isOpen={isReturnDeposit}
        onClose={() => setIsReturnDeposit(false)}
      >
        <ReturnDeposit
          setIsReturnDeposit={setIsReturnDeposit}
          returnDepositMutate={returnDepositMutate}
          returnDepositLoading={returnDepositLoading}
          isReturnDeposit={isReturnDeposit}
          selectedData={selectedData}
          setSelectedData={setSelectedData}

        />
      </SideModal>

      <SideModal
        isOpen={isGuestReqAccept}
        onClose={() => setIsGuestReqAccept(false)}
        level="high"
        width="1/3"
      >
        <GuestReqAccept
          setIsGuestReqAccept={setIsGuestReqAccept}
          guestReqMutate={guestReqMutate}
          guestReqLoading={guestReqLoading}
          isGuestReqAccept={isGuestReqAccept}
          selectedData={selectedData}
          setSelectedData={setSelectedData}

        />
      </SideModal>

      <SideModal
        isOpen={onboardingRequestAccept}
        onClose={() => setOnboardingRequestAccept(false)}
      >
        <OnboardingRequestModal
          setOnboardingRequestAccept={setOnboardingRequestAccept}
          onboardingRequestMutate={onboardingRequestMutate}
          onboardingRequestLoading={onboardingRequestLoading}
          onboardingRequestAccept={onboardingRequestAccept}
          selectedData={selectedData}
          setSelectedData={setSelectedData}

        />
      </SideModal>

      <SideModal
        isOpen={initiateEviction}
        onClose={() => setInitiateEviction(false)}
      >
        <InitiateTenantEviction
          setInitiateEviction={setInitiateEviction}
          apiData={{
            name: selectedData.tenantName,
            kycStatus: selectedData.kycStatus,
            occupancy: {
              requestId: selectedData.id,
              tenantId: selectedData.tenantId,
              roomNum: selectedData.roomNum,
              floor: selectedData.floor,
              propName: selectedData.propertyName,
              flatname: selectedData.flatName,
              moveInDate: selectedData.moveInDate,
              agreementPeriod: selectedData.agreementPeriod,
              lockInPeriod: selectedData.lockInPeriod,
              noticePeriod: selectedData.noticePeriod,
              agreementStartDate: selectedData.agreementStartDate,
              moveOutDate: selectedData.moveOutDate,
              moveOutReason: selectedData.moveOutReason,
              otherDate: selectedData.otherDate,
              calculationType: selectedData.calculationType
            }
          }}
        />
      </SideModal>

      <SideModal
        isOpen={isViewReq}
        onClose={() => setIsViewReq(false)}
      >
        <ViewRequest
          setIsViewReq={setIsViewReq}
          selectedData={selectedData}
          setIsReqRej={setIsReqRej}
          setInitiateEviction={setInitiateEviction}
          setIsReturnDeposit={setIsReturnDeposit}
          setOnboardingRequestAccept={setOnboardingRequestAccept}
          setIsReqAccept={setIsReqAccept}
          setIsGuestReqAccept={setIsGuestReqAccept}
        />
      </SideModal>

      {!error && !isLoading && data && (
        <TableWrapper>
          <Table
            apiData={apiData || []}
            setSelectedData={setSelectedData}
            selectedData={selectedData}
            setIsReqRej={setIsReqRej}
            setInitiateEviction={setInitiateEviction}
            setIsViewReq={setIsViewReq}
            setIsReturnDeposit={setIsReturnDeposit}
            setOnboardingRequestAccept={setOnboardingRequestAccept}
            setIsReqAccept={setIsReqAccept}
          />
          {(!apiData || apiData.length === 0) && <NotFoundModel msg={"No pending requests at the moment."} />}
        </TableWrapper>
      )}

      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`my-8 border bg-white rounded-md`;

export default Requests;
